import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { User } from 'src/app/models';
import { environment as env } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class GetGalleryService {
  private baseUrl = `${env.apiCerberoUrl}`;

  constructor(private httpClient: HttpClient) {}

  getGallery(id: string) {
    return this.httpClient.get<any>(`${this.baseUrl}/request?event=find-gallery&id=${id}`);
  }
  
}
